export const ru = {
  yachtExp: 'Яхтенный опыт',
  nauticalMiles: 'морских миль',
  days: 'Дней',
  filterSet: 'настроить фильтр',
  editColumns: 'Добавить/скрыть столбцы',
  viewMode: 'настроить вид отображения логбука',
  hide: 'скрыть',
  sendLog: 'Отправить логбук',
  yacht: 'Яхта',
  miles: 'Мили',
  marinaStart: 'Марина старта',
  chooseMarinaStart: 'Выберите марину старта',
  marinaFinish: 'Марина финиша',
  chooseMarinaFinish: 'Выберите марину финиша',
  route: 'Маршрут',
  routeDetails: 'Введите детали маршрута',
  description: 'Примечания',
  tidalRegion: 'Приливной регион',
  nonTidalRegion: 'Не приливной регион',
  allPeriod: 'За весь период',
  enterManually: 'Ввести вручную',
  allTimeFrom: 'Все время от',
  allTimeUntil: 'Все время до',
  lastYear: 'Последний год',
  from: 'От',
  until: 'До',
  choose: 'Выбрать',
  clearFilters: 'Сбросить все фильтры',
  confirmMail: 'Мы отправили вам письмо, подтверждающее вашу электронную почту. Проверьте свои входящие.',
  addMail: 'Чтобы пользоваться функционалом Логбука, пожалуйста, добавтьте свой e-mail.',
  sendAgain: 'Ваша почта не подтверждена.\n Отправить еще одно письмо с подтверждением?',
  confirmMailTost: 'Подтвердите свою электронную почту, чтобы воспользваться всем функционалом логбука',
  confirmSend: 'Да, отправить',
  sendAgainShort: 'Отправить еще раз',
  confirmMailTitle: 'Подтвердить e-mail',
  cancel: 'Отмена',
  addTrip: 'Добавить яхтенный поход',
  editTrip: 'Редактировать яхтенный поход',
  deleteTrip: 'Удалить яхтенный поход',
  isDeleteTrip: 'Вы действительно хотите удалить этот поход из логбука?',
  infoTrip: 'Информация о походе',
  dates: 'Даты',
  startDate: 'Дата старта',
  finishDate: 'Дата финиша',
  role: 'Роль',
  isntChosen: 'Не выбрано',
  yourRole: 'Ваша роль в яхтенном походе',
  tidal: 'Приливный регион',
  nmPassed: 'Пройдено миль',
  nightHours: 'Ночные часы',
  nh: 'н/ч',
  infoYacht: 'Информация о яхте',
  model: 'Модель',
  enterModel: 'Название модели',
  yachtName: 'Название яхты',
  addNewModel: 'Создать новую модель',
  year: 'Год',
  chooseYear: 'Выберите год',
  chooseYearList: 'Выберите год из списка',
  ownerShip: 'Собственность',
  charter: 'Чартерная',
  private: 'Частная',
  operator: 'Оператор',
  yachtOwner: 'Владелец яхты',
  notChosen: 'Не выбрано',
  addToFavYacht: 'Добавить яхту в избранное',
  sailRegion: 'Регион плавания',
  startBase: 'Марина старта',
  chooseStartBase: 'Выберите марину старта',
  country: 'Страна',
  countryStart: 'Страна старта',
  chooseCountryStart: 'Выберите страну старта',
  countryFinish: 'Страна финиша',
  chooseCountryFinish: 'Выберите страну финиша',
  choseCountryList: 'Выберите страну со списка',
  finishBase: 'Марина финиша',
  equalStartFinish: 'Точка финиша соответсвует старту',
  chooseFinishBase: 'Выберите марину финиша',
  chooseFinishCountry: 'Выберите страну финиша',
  sailingIt: 'Маршрут',
  enterRouteDetails: 'Введите детали о маршруте',
  tripDetails: 'Детали путешествия',
  tripDetailsHolder: 'Отметьте любые данные, которые считаете важными, к примеру, погодные условия, тип похода и т.д.',
  crewList: 'Крю-лист',
  fileNotChosen: 'Файл не выбран',
  chooseFile: 'Выбрать файл',
  chooseFileFormat: 'Выберите файл формата PDF, PNG, JPEG, JPG размером не более 10 Мб.',
  save: 'Сохранить',
  saveDraft: 'Сохранить как черновик',
  profile: 'Мой профиль',
  licenses: 'Лицензии',
  favYachts: 'Избранные яхты',
  yachts: 'Яхты',
  myTeam: 'Команда',
  sailResume: 'Резюме шкипера',
  resume: 'Резюме',
  info: 'info',
  resetPassword: 'Сменить пароль',
  signOut: 'Выйти',
  deleteAc: 'Удалить профиль',
  daysInTheSea: 'дней в походе',
  email: 'Почта',
  editProfile: 'Редактировать профиль',
  name: 'Имя',
  surname: 'Фамилия',
  phone: 'Телефон',
  recoveryLetter: 'На вашу почту было отправлено письмо для изменения пароля',
  sendLicense: 'Отправить лицензию',
  sendLicenses: 'Отправить лицензии',
  addLicense: 'Добавить лицензию',
  issuedBy: 'Выдана',
  tintIyt: 'вы можете найти IYT id с задней части лицензии',
  licenseNumber: 'Номер лицензии',
  licenseType: 'Тип лицензии',
  chooseLicenseType: 'Введите тип лицензии',
  sailSchool: 'Школа',
  instructor: 'Инструктор',
  issueDate: 'Дата выдачи',
  chooseIssueDate: 'Выберите дату выдачи',
  chooseStartDate: 'Выберите дату выдачи',
  chooseFinishDate: 'Выберите срок действия',
  unlimited: 'Бессрочная',
  validTill: 'Срок действия',
  expiryDate: 'Срок действия',
  chooseExpiryDate: 'Выберите срок действия',
  frontSide: 'Передняя часть',
  backSide: 'Задняя часть',
  choosePhoto: 'Выбрать фото',
  add: 'Добавить',
  attachSailResume: 'Прикрепить мое резюме',
  recepients: 'Получатели',
  enterRecepientsMail: 'Введите e-mail получателя',
  messageToRecepient: 'Сообщение получателю',
  messageToRecepientLicenseHolder: 'Привет! В прикрепленных файлах - лицензии шкипера Олега Литвина и резюме шкипера.',
  messageToRecepientLogbookHolder: 'Привет! Высылаю свой логбук.',
  copyLink: 'Копировать ссылку',
  addNewFavYacht: 'Добавить новую яхту в "Избранные"',
  addYacht: 'Добавить яхту',
  modelName: 'Название модели',
  chooseYearProd: 'Выберите год',
  yachtType: 'Тип яхты',
  enterYachtType: 'Введите тип яхты',
  length: 'Длина',
  width: 'Ширина',
  metres: 'м',
  fleetOperator: 'Название оператора',
  operatorTint: 'Выберите название оператора из списка или введите имя владельца яхты, если она частная',
  uploadPhoto: 'Загрузить фото',
  edit: ' Редактировать',
  editYachtInfo: 'Редактировать информацию о яхте',
  change: 'Изменить',
  deleteYacht: 'Удалить яхту',
  isDeleteYacht: 'Вы действительно хотите удалить яхту',
  fromFav: 'из избранных яхт?',
  commonTrips: 'Общие походы',
  sailedTogether: 'Пройдено вместе',
  delFriend: 'Удалить пользователя',
  isDelFriend: 'Вы действительно хотите удалить пользователя Ronald Richards',
  fromTeam: ' из команды?',
  hasntCreatedResume: 'У Вас пока нет резюме',
  toCreateResume: 'Для того чтобы создать резюме нажмите кнопку “Создать резюме”',
  beforeCreateResume: 'Перед созданием Резюме шкипера загрузите лицензии в раздел "Лицензии". И добавьте хотя одну запись в Логбук',
  createResume: 'Создать резюме',
  personalInfo: 'Персональная информация',
  skipper: 'Шкипер',
  enterName: 'Введите имя на английском языке',
  enterSurname: 'введите фамилию на английском языке',
  birthDate: 'Дата Рождения',
  phoneNumber: 'Номер телефона',
  address: 'Адресс проживания',
  addressPlaceholder: 'Town, Country',
  howLongSailing: 'Как давно занимаетесь яхтингом?',
  since: 'С',
  years: 'Лет',
  doHaveLicenses: 'У вас есть яхтенные лицензии шкипера?',
  yes: 'Да',
  no: 'Нет',
  doOwnBoat: 'Вы владеете (или владели) яхтой?',
  haveBareboat: 'Вы арендовали яхту в чартер ранее (без экипажа)?',
  charterCompany: 'Чартерная компания',
  sizeTypeBoat: 'Размер и тип яхты ',
  nm: 'миль',
  sailingArea: 'Регион плавания',
  showMoreCharters: 'Показать больше чартеров',
  totalExp: 'Опыт в роли ',
  showLogbookLink: 'Добавить ссылку на мой логбук',
  knowAndExp: 'Отметьте ваши знания и опыт',
  dockingAlongside: 'Швартовка лагом',
  readingNaut: 'Чтение морских карт',
  pickMoor: 'Постановка на муринг',
  plotting: 'Прокладка маршрута',
  coastNav: 'Навигация в прибрежных водах',
  signleBow: 'Постановка на якорь',
  crewMan: 'Компетентный член команды (помощник шкипера)',
  isAddCrew: 'Добавьте информацию о компетентном помошнике в предстоящем путешествии',
  inviteMember: 'Пригласить пользвователя',
  toAddTheDataEnterMail: 'Чтобы заполнить даныне о Вашем помощнике введите его имейл:',
  notFound: 'Не обнаружен',
  shareTrip: 'Поделиться с ним моими походами',
  share: 'Поделиться',
  shareTint: 'Ваш друг, с которым вы поделились записью получит уведомление с предложением добавить этот поход в свой логбук.',
  send: 'Отправить',
  delete: 'Удалить',
  invite: 'Пригласить',
  fine: 'Превосходно!',
  excellent: 'ОТЛИЧНО',
  logbookSended: 'Копия логбука была отправлена:',
  crewPersonalInfo: 'Персональная информация члена команды:',
  addAnotherTrip: 'Добавить еще один поход',
  iCertify: 'Я подтверждаю, что представленная выше информация правдива. Я осведомлен и согласен с тем, что если мои навыки и компетенции в управлении яхтой недостаточны в этом регионе, то Владелец яхты может отменить чартер или предоставить квалифицированного шкипера с оплатой его услуг за счет клиента.',
  sendResume: 'Отправить резюме шкипера',
  enterRecMail: 'Введите e-mail получателя',
  recipients: 'Получатели',
  attachLicenses: 'Прикрепить мои лицензии',
  addUpcomingCharter: 'Добавить данные по предстоящему чартеру',
  bookingNumber: 'Номер брони/контракта',
  clientsName: 'Имя клиента',
  departureDate: 'Дата старта',
  departureBase: 'База старта',
  arrivalDate: 'Дата финиша',
  arrivalBase: 'База финиша',
  hello: 'Приветствую!',
  yourLogEmpty: 'В вашем Online-Logbook пока нет ни одной записи.',
  pressPlusToAdd: 'Для того чтоб добавить первую запись нажмите кнопку добавить трип “+”',
  messageResumeHolder: 'Привет!\nОтправляю вам свое Резюме Шкипера.',
  preview: 'Просмотреть',
  signUp: 'Регистрация',
  password: 'Пароль',
  confirmPassword: 'Подтвердить пароль',
  agreePolitics: 'Регистрируясь, вы подтверждаете, что принимаете нашу',
  privacy: 'Политику конфиденциальности и Правила пользования.',
  isHaveAc: 'Уже зарегистрированы?',
  signIn: 'Войти',
  isForgotPass: 'Забыли пароль?',
  dontHaveAc: 'Еще нет аккаунта?',
  getStarted: 'Зарегистрируйся',
  darkTheme: 'Темная тема',
  logbook: 'Логбук',
  changePassword: 'Сменить пароль',
  organization: 'Организация',
  enterOrg: 'Введите название организации',
  selectLicenseToSend: 'Выберите лицензии для отправки',
  editLicense: 'Редактировать лицензию',
  licenseSystem: 'Лицензионная система',
  deleteLicense: 'Удалить лицензию',
  isDeleteLicense: 'Вы действительно хотите удалить лицензию',
  notRegisteredInfo: 'Этот пользователь еще не зарегистрирован в Online logbook.',
  myProfile: 'Мой профиль',
  newNotifications: 'Новых уведомлений',
  sharedYachtTrip: 'поделился с тобой яхтенным походом',
  wantsToEdit: 'Олег Литвин хочет внести изменения в поход',
  isAccept: 'Принимаете ли вы их?',
  decline: 'Отклонить',
  accept: 'Принять',
  addIytLicenses: 'Добавление IYT лицензий',
  notFoundIYT: 'Для вашего IYT ID не найдено лицензий',
  selectAll: 'Выбрать все',
  changingPassword: 'Смена пароля',
  oldPassword: 'Старый пароль',
  newPassword: 'Новый пароль',
  confirmPass: 'Подтверждение пароля',
  incorrectOldPassword: 'Введен неправильный старый пароль',
  hideTrips: 'Скрыть походы',
  isHideTrips: 'Вы действительно хотите скрыть все свои походы в разделе “Резюме”?',
  confirmHide: 'Да, скрыть',
  notHide: 'Нет, не скрывать',
  dateStartAndFinish: 'Дата старта/финиша',
  milesTraveled: 'Миль пройдено',
  chooseYacht: 'Выберите яхту',
  savedInDraft: 'Ваша запись сохранена как “Черновик”. Заполните все необходимые данные, чтобы она была активной, а морские мили засчитаны в ваш шкиперский опыт.',
  //errors
  requiredField: 'Это поле обязательно для заполнения',
  emailOrPasswordIncorrect: 'Почта или пароль введены неправильно',
  emailExist: 'Введенный email уже существует',
  passwordMismatch: 'Пароли не совпадают',
  mailDoesNotExist: 'Такой почты не существует',
  passwordChars: 'Пароль должен содержать 8 символов',
  modelNotFound: 'Модель не найдена. Пожалуйста, выберите модель из списка или создайте новую',
  operatorNotFound: 'Оператор не найден. Пожалуйста, выберите оператора из списка',
  countryStartNotFound: 'Страна не найдена. Пожалуйста, выберите страну старта из списка',
  countryFinishNotFound: 'Страна не найдена. Пожалуйста, выберите страну финиша из списка',
  marinaStartNotFound: 'Марина не найдена. Пожалуйста, выберите марину старта из списка',
  marinaFinishNotFound: 'Марина не найдена. Пожалуйста, выберите марину финиша из списка',
  marinaNotFoundInCountry: 'В этой стране не существует выбранной марины: ',
  selectDates: 'Пожалуйста, выберите даты',
  selectRole: 'Пожалуйста, выберите роль из списка',
  selectStartCountry: 'Пожалуйста, выберите страну старта из списка',
  selectFinishCountry: 'Пожалуйста, выберите страну финиша из списка',
  selectModel: 'Пожалуйста, введите название модели',
  selectYachtType: 'Пожалуйста, выберите тип яхты из списка',
  shipyardNotFound: 'Такая верфь в базе данных не обнаружена, выберите значение “Индивидуальная постройка/Custom shipyard”. если считаете, что нам стоит внести новую верфь в Базу данных системы - напишите нам на info@online-logbook.eu',
  enterYachtLength: 'Пожалуйста, введите длину яхты',
  enterYachtWidth: 'Пожалуйста, введите ширину яхты',
  enterNameModel: 'Пожалуйста, введите название модели',
  countryNotFound: 'Страна не найдена. Пожалуйста, выберите страну из списка',
  licenseTypeNotFound: 'Тип лицензии не найден. Пожалуйста, выберите тип лицензии из списка',
  enter: 'Введите',
  onlyEnglish: 'на английском языке',
  chooseYearYacht: 'Чтобы добавить яхту в избранное, выберите год из списка',
  enterYachtName: 'Чтобы добавить яхту в избранное, введите имя яхты',
  invalidDate: 'Некорректная дата',
  // new
  marinaNotFound: 'Марина не найдена. Пожалуйста, выберите марину из списка',
  sailBoatLicenses: 'Яхтенные лицензии',
  boat: 'Яхта',
  type: 'Тип',
  port: 'Порт',
  charterExp: 'Яхтенный опыт',
  knowAndExpLabel: 'Знания и опыт:',
  infoCrew: 'Информация про члена команды.',
  howLongCrewSail: 'Как долго он/она занимается яхтингом?',
  isCrewLicenses: 'Есть ли у него/нее яхтенные лицензии шкипера?',
  isCrewBoat: 'Владеет (или владел) он/она яхтой?',
  chartersBefore: 'Ранние чартерные походы.',
  isCrewCharteredBefore: 'Арендовал ли он/она яхту в чартер ранее (без экипажа)?',
  identifyCrewExp: 'Отметьте его/её знания и опыт:',
  orFullManually: 'или заполните вручную:',
  date: 'Дата',
  hideTripInResume: 'Скрыть этот поход в Резюме',
  showTripInResume: 'Показать этот поход в Резюме',
  chooseYachtType: 'Выберите тип яхты из списка',
  sendConfirmation: 'Отправить подтверждение',
  notConfirmed: 'Email не подтвержден',
  sentEmailForPassword: 'На вашу почту было отправлено письмо для изменения пароля',
  passwordCahnged: 'Пароль успешно изменен!',
  errorPassword: 'При изменении пароля произошла ошибка. Повторите попытку позже.',
  startDateBiggerEndDate: 'Дата старта не может быть позже чем дата финиша',
  showMore: 'Показать больше',
  requestToDelete: 'Запрос на удаление моей учетной записи и данных',
  areYouSure: 'Вы уверенны?',
  acceptDelete: 'Да, удалить',
  cancelDelete: 'Нет, отменить',
  jan: 'янв',
  feb: 'фев',
  mar: 'мар',
  apr: 'апр',
  may: 'мая',
  june: 'июня',
  july: 'июля',
  aug: 'авг',
  sep: 'сен',
  oct: 'окт',
  nov: 'нояб',
  dec: 'дек',
  passwordRecovery: 'Восстановление пароля',
  enterEmail: "Введите почту",
  editingTrip: 'Редактирование похода',
  isShareChanges: 'Вы хотите поделиться этими изменениями с другими участниками похода?',
  delivered: 'Добавлено',
  cancelled: 'Отменено',
  days_short: 'дн',
  successRegister: 'Вам отправлено письмо на почту с ссылкой для подтверждения регистрации.\nПерейдите по ссылке для завершения регистрации.',
  loadImagesForLicenses: 'Загрузите также фотографии лицензий, чтобы в будущем их отправлять в пару кликов',

  tripTeam: 'Участники похода',
  sendInvitation: 'приглашение отправлено',
  successAccept: 'Ваша почта успешно подтверждена!',
  inviteByLink: 'Пригласить по ссылке',
  expiredLabelFirst: 'Срок действия ссылки для подтверждения регистрации истек.',
  expiredLabelSecond: ' Отправить новую ссылку на вашу почту для подтверждения?',
  page404: 'Увы, но эта страница затерялась где-то в океане Интернета',
  toMain: 'Перейти на главную'
}
